import { createElement } from "react";
import { RouteObject } from "react-router-dom";
import { JournalSectionPersonnelPage } from "@/features/journal-section-personnel";
import { routes } from "@shared/lib/react-router";
import { JournalsSectionFirst } from "./ui";
import { JournalSectionFormPage } from "./ui/journal-section-form-page";
import { JournalSectionInfoPage } from "./ui/journal-section-info-page";

export const JournalsSectionFirstRoute = (
  ...rest: RouteObject[]
): RouteObject => {
  return {
    path: `${routes.journals.section1()}`,
    element: createElement(JournalsSectionFirst),
    children: [
      {
        path: `form/:itemNoVersionId?`,
        element: createElement(JournalSectionFormPage),
      },
      {
        path: `view/:itemNoVersionId`,
        element: createElement(JournalSectionInfoPage),
      },
      {
        path: "personnel",
        element: createElement(JournalSectionPersonnelPage, { sectionNumber: 1 }),
      },
      ...rest,
    ],
  };
};

export const JournalsSectionFirstVersionRoute = (
  ...rest: RouteObject[]
): RouteObject => {
  return {
    path: `${routes.journals.journalVersionSection1()}`,
    element: createElement(JournalsSectionFirst),
    children: [
      {
        path: `form/:itemNoVersionId?`,
        element: createElement(JournalSectionFormPage),
      },
      {
        path: `view/:itemNoVersionId`,
        element: createElement(JournalSectionInfoPage),
      },
      {
        path: "personnel",
        element: createElement(JournalSectionPersonnelPage, { sectionNumber: 1 }),
      },
      ...rest,
    ],
  };
};
